import React, { useRef, useEffect } from 'react';
import classnames from 'classnames';
import { find } from 'lodash';
import { parse } from 'node-html-parser';

/**
 * @function parseStyles
 * Parses a string of inline styles into a javascript object with casing for react
 *
 * @param {string} styles
 * @returns {Object}
 */
const parseStyles = styles =>
  styles
    .split(';')
    .filter(style => style.split(':')[0] && style.split(':')[1])
    .map(style => [
      style
        .split(':')[0]
        .trim()
        .replace(/-./g, c => c.substr(1).toUpperCase()),
      style.split(':')[1].trim(),
    ])
    .reduce(
      (styleObj, style) => ({
        ...styleObj,
        [style[0]]: style[1],
      }),
      {},
    );

export function ServerSideRendered({ data, ...rest }) {
  const { rendered: markup } = data;
  const ref = useRef(null);

  const parsed = parse(markup.trim());

  useEffect(() => {
    const node = ref.current;

    if (node) {
      node.innerHTML = last.innerHTML;
    }

    return () => {};
  }, [ref.current]); // Recall only if ref changes

  if (!markup || !parsed) return <></>;

  const last = find(parsed.childNodes, 'tagName');

  // if (rest.pause === true) {
  //     console.log(last);
  // }

  // if (parsed.attributes) {
  //     console.log(markup.trim());
  //     console.log(parsed);
  // }

  // if (last.tagName === 'h2') {
  //     console.log(markup);
  //     console.log(parsed);
  // }

  if (!last) return <></>;

  const { tagName: Tag, attributes } = last;

  const rawId = attributes.id;
  const rawClassNames = attributes.class;
  const rawStyles = attributes.style;
  const classNames = rawClassNames && classnames(rawClassNames);
  const style = rawStyles && parseStyles(rawStyles);

  return <Tag ref={ref} id={rawId} className={classNames} style={style} />;
}
